import { Outlet, useLocation } from 'react-router-dom'
import { Header } from '@/components/Header'
import { Footer } from '@/components/Footer'
import { cn } from '@/lib/utils'

export default function Layout() {
  const location = useLocation()
  const isAuthPage =
    location.pathname === '/login' || location.pathname === '/signup'

  return (
    <div className="flex flex-col min-h-screen bg-background">
      <Header />
      <main className={cn('flex-grow', !isAuthPage && 'pt-[72px]')}>
        <Outlet />
      </main>
      <Footer />
    </div>
  )
}
